import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_Row,
} from 'material-react-table';
import { Box, Button, Stack } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useNavigate, useParams } from 'react-router-dom';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { useEffect, useRef, useState } from 'react';
import { AxiosInstance } from '../../api/apiInstance';
import { IRootreportInfo } from './ReportViewData';
import { muiTableBodyCellPropsHelper, muiTableHeadCellPropsHelper } from '../../helper/helper';



const columns = [
    {
        //columnHelper.accessor('id', {
        accessorKey: 'ID',
        header: 'ID',
        enableHiding: true,
        //}
    },
];

const ReportInfo = () => {
    let { reportName } = useParams();
    const navigate = useNavigate();
    const [rptInfo, setrptInfo] = useState<IRootreportInfo>();
    const [isLoadingTasks , setIsLoadingTasks] = useState(true);
    const [isFetchingTasks , setisFetchingTasks] = useState(true);
    const columns = useRef([
      {
          //columnHelper.accessor('id', {
          accessorKey: 'ID',
          header: 'ID',
          enableHiding: true,
          //}
      },
  ]);
    
    let yourDate = new Date()
     //READ hook (get reports from api)

     
   
     useEffect(()=> {
        async function GetData() {
            try {
              return await AxiosInstance({
                // url of the api endpoint (can be changed)
                url: "report-view/"+ reportName,
                method: "GET",
              }).then((res) => {
                // handle success
               
                setrptInfo( res.data)
              });
            } catch (e) {
              // handle error
              console.error(e);
             
            }
          }        
        GetData();                    
     },[])

     useEffect(()=> {
        columns.current  = columns.current.filter(()=>{});
        rptInfo?.fields.forEach((f) => {
                columns.current.push(
                    {
                        accessorKey: f.name,
                        header: f.name,
                        enableHiding: true,
                    },
                )
            })
            setisFetchingTasks (false); 
            setIsLoadingTasks (false);
          }
        ,[rptInfo])

   
    

    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: reportName + '-' + yourDate.toISOString().split('T')[0] });

    const handleExportData = () => {
        // Converts your Array<Object> to a CsvOutput string based on the configs
        if (rptInfo !== undefined)
        {
          const csv = generateCsv(csvConfig)(rptInfo?.data);
          download(csvConfig)(csv);
        }
  
    };
    const handleExportRows = (rows: MRT_Row<any>[]) => {
        
        //const tableData = rows.map((row) => Object.values(row.original));
        const rowData = rows.map((row) => row.original);
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
        
      };

        

    const table = useMaterialReactTable({
        columns: columns.current,
        data:rptInfo? rptInfo.data : [],
        enableRowSelection: true,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        
        initialState: { columnVisibility: { ID: false } ,  density: 'compact',pagination: { pageSize: 50, pageIndex: 0 }, },
        muiTableBodyProps: {
          sx: {
            //stripe the rows, make odd rows a darker color
            '& tr:nth-of-type(odd) > td': {
              backgroundColor: '#f5f5f5',
            },
          },
        },
        muiTableHeadCellProps: {
          //no useTheme hook needed, just use the `sx` prop with the theme callback
          sx: (theme) => (muiTableHeadCellPropsHelper),
        }, 
          muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            sx: {
              muiTableBodyCellPropsHelper
            },
          }),
                
          muiTableContainerProps: {
            sx: {
              minHeight: '500px',
              padding: '1rem',
              margin: '1rem',
              textAlign: 'center',
            },
          },
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Data
                </Button>        
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button> 
            </Box>
        ),
        state: {
          isLoading: isLoadingTasks,              
          showProgressBars: isFetchingTasks,
        },
    });

    return (
        <>

            <Stack
                direction="row"
                spacing={2}
                padding={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <h2> report lines: {rptInfo?.data.length}</h2>
                <h1>  {reportName}
                   
                </h1>
                <Button size="small" onClick={() => navigate('/reports')}>Back</Button>

            </Stack>
            <MaterialReactTable table={table} />;
        </>)

};

export default ReportInfo;
